import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import axios from "axios";
import toast from "react-hot-toast";

const WorkOrderList = () => {
  const navigate = useNavigate();

  const [orderList, setOrderList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchOrder, setSearchOrder] = useState("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteOrderId, setDeleteOrderId] = useState(null);

  const openDeleteModal = (orderId) => {
    setDeleteOrderId(orderId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteOrderId(null);
    setShowDeleteModal(false);
  };

  const fetchOrders = async () => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/orders?page=0&size=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Orders => ", response.data);

      setOrderList(response?.data?.content || []);
    } catch (error) {
      console.log(error);

      toast.error("Failed To Fetch Orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleDeleteOrder = async (orderId) => {
    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/orders/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setOrderList((prev) => prev.filter((order) => order.orderId !== orderId));

      toast.success("Work Order Deleted Successfully");

      closeDeleteModal();
    } catch (error) {
      console.log(error);

      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed To Delete Work Order";

      toast.error(errorMessage);
    }
  };

  const filteredOrders = orderList.filter((order) =>
    (order.organizationName || order.referenceOrderNumber || "")
      .toLowerCase()
      .includes(searchOrder.toLowerCase()),
  );

  return (
    <Layout>
      <div className="backgound-main-content p-4">
        <div className="container-fluid">
          {/* Header */}

          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
            <h3 className="fw-bold mb-0">Work Order List</h3>

            <button
              className="btn btn-primary"
              onClick={() => navigate("/work-order")}
            >
              Create Work Order
            </button>
          </div>

          {/* Search */}

          <div className="mb-4 w-25">
            <input
              type="text"
              className="form-control"
              placeholder="Search Organization"
              value={searchOrder}
              onChange={(e) => setSearchOrder(e.target.value)}
            />
          </div>

          {/* Table */}

          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>Sr No</th>
                  <th>Reference No</th>
                  <th>Order Id</th>
                  <th>Type</th>
                  <th>Order Date</th>
                  <th>Organization</th>
                  {/*
                  <th>GST Type</th>
                  <th>Sub Total</th>
                  */}
                  <th>Total</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="8" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : filteredOrders.length > 0 ? (
                  filteredOrders.map((order, index) => (
                    <tr key={order.orderId}>
                      <td>{index + 1}</td>

                      <td>{order.referenceOrderNumber}</td>
                      <td>{order.orderId}</td>
                      <td>{order.partyType}</td>

                      <td>{order.orderDate}</td>

                      <td>{order.organizationName}</td>
                      {/*
                      <td>{order.gstType}</td>

                      <td>₹ {order.subTotal || 0}</td>
                      */}

                      <td className="fw-bold">₹ {order.total || 0}</td>

                      <td>
                        <div className="d-flex gap-2">
                          {/* View */}

                          <Icon
                            icon="hugeicons:view"
                            style={{
                              color: "#00AFEF",
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              navigate(`/work-order-view/${order.orderId}`)
                            }
                          />

                          {/* Edit */}

                          <Icon
                            icon="mdi:edit"
                            style={{
                              color: "#00AFEF",
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              navigate("/work-order", {
                                state: {
                                  orderId: order.orderId,
                                  isEdit: true,
                                },
                              })
                            }
                          />

                          {/* Delete */}

                          <Icon
                            icon="material-symbols:delete-outline"
                            width="20"
                            style={{
                              color: "#DD0000",
                              cursor: "pointer",
                            }}
                            onClick={() => openDeleteModal(order.orderId)}
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No Work Order Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Delete Modal */}

      <div
        className={`modal fade ${showDeleteModal ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center">
              <h4>Confirm Delete</h4>

              <p>Are you sure you want to delete this Work Order?</p>

              <div className="d-flex justify-content-center gap-2">
                <button
                  className="btn btn-secondary"
                  onClick={closeDeleteModal}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-danger"
                  onClick={() => handleDeleteOrder(deleteOrderId)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default WorkOrderList;
